<template>
  <m-form class="m-form-organization-edit-without-member-id" ref="form">
    <template #content class="content">
      <v-flex pb-3 v-if="authenticated">
        <e-typography-heading-3>Unternehmensanschrift</e-typography-heading-3>
      </v-flex>
      <v-layout row wrap>
        <v-flex xs12 pa-0>
          <v-flex xs12 class="pb-0">
            <e-input-company-name v-model="form.name"
                                  required-style
                                  rules="required|company"
                                  :disabled="!canUpdate"
                                  name="name" ref="name"/>
          </v-flex>

          <v-flex xs12 class="pb-0">
            <e-input-company-id
                    v-model="form.identifierName"
                    permanentlyDisabled
                    :tooltip="breakpoints.isLessThanTablet ? null : companyIdTooltipText"
                    ref="companyId"
            />
          </v-flex>

          <v-flex xs12 class="pb-0 pt-0">
            <e-input-company-street v-model="form.address" :disabled="!canUpdate" name="address" ref="address"/>
          </v-flex>

          <v-flex xs12 class="pb-0 pt-0">
            <e-input-company-postcode v-model="form.postCode" :disabled="!canUpdate" name="postCode" ref="postCode"/>
          </v-flex>

          <v-flex xs12 class="pb-0 pt-0">
            <e-input-company-place v-model="form.city" :disabled="!canUpdate" name="city" ref="city"/>
          </v-flex>
        </v-flex>
      </v-layout>
    </template>
    <template #buttons v-if="canUpdate">
      <m-block-form-buttons
          :status="buttonStatus"
          :text="buttonsText"
          :isLoading="$wait.waiting(keys.organizations.update)"
          @submit="submit"
          @cancel="cancel"/>
    </template>
  </m-form>
</template>

<script>
import MForm from "@modules/forms/m-form";
import MBlockFormButtons from "@modules/blocks/buttons/concrete/m-block-form-buttons";

import {mapActions, mapGetters} from 'vuex';
import vuexKeys from '@mixins/includes/_vuexKeys'
import notifications from "@mixins/includes/_notifications";
import resources from "@mixins/permissions/_resources";
import errorHandler from "@mixins/responses/_errorHandler";
import ETypographyHeading3 from "@elements/typography/e-typography-heading-3";

export default {
  name: "m-form-organization-edit-without-member-id",
  components: {ETypographyHeading3, MForm, MBlockFormButtons},
  mixins: [vuexKeys, notifications, resources, errorHandler],
  $_veeValidate: {
    validator: 'new'
  },
  data: () => ({
    form: {
      name: null,
      address: null,
      postCode: null,
      city: null,
      _id: null,
    },
    formLoaded: false,
    buttonStatus: "submitDisabled"
  }),
  async created() {
    if (!this.organization.length) {
      await this.requestOrganization({id: this.organizationId});
    }

    Object.assign(this.form, this.organization);
  },
  computed: {
    ...mapGetters({
      getOrganization: 'organizations/read'
    }),
    buttonsText() {
      return {
        cancel: this.$t('modules.forms.m-form-profile.buttons.cancel'),
        submit: this.$t('modules.forms.m-form-profile.buttons.submit')
      }
    },
    companyIdTooltipText() {
      return this.$t('modules.forms.m-form-company-reg-step4.inputs.organization-id.tooltip')
    },
    organizationId() {
      return this.$user.relationships.organization.data.id;
    },
    organization() {
      return this.getOrganization(this.organizationId)
    },
    canUpdate() {
      return this.$can(this.$actions.update, this.$abilitySubjects.organization)
    }
  },
  methods: {
    ...mapActions({
      requestOrganization: 'organizations/read',
      updateOrganization: 'organizations/update'
    }),
    submit() {
      this.$validator.validateAll().then(async (success) => {
        if (success) {
          try {
            await this.updateOrganization(this.form);
            this.notify.success(this.$t('notifications.profile.editProfile.edited'));
            // this.goBack();
          } catch (e) {
            this.error.handle(e)
          }
        } else {
          const el = document.querySelector(".v-messages__message");
          el.scrollIntoView({behavior: "smooth", block: "center"});
          this.notify.error(this.$t('notifications.errors.formErrors.invalid'))
        }
      });
    },
    cancel() {
      this.goBack();
    },
    checkFormStatus() {
      if (this.formLoaded && this.buttonStatus == "submitDisabled") this.buttonStatus = "submitActive"
    }
  },
  watch: {
    'form.name'(newVal, oldVal) {
      if (oldVal == null) {
        setTimeout(() => {
          this.formLoaded = true
        }, 200)
      }
      this.checkFormStatus()
    },
    'form.address'() {
      this.checkFormStatus()
    },
    'form.city'() {
      this.checkFormStatus()
    },
    'form.postCode'() {
      this.checkFormStatus()
    }
  }
}
</script>

<style lang="scss">
.m-form-organization-edit-without-member-id {
  .v-divider {
    display: none;
  }
}

.app-layout__auth {
  .m-form-organization-edit-without-member-id {
    padding-left: 1rem;
    padding-right: 1rem;

    .m-form-content {
      box-shadow: 0px 0px 4px 0px rgba(0, 73, 148, 0.61);
      border-radius: 3px;
      padding: .5rem 0 1rem 0;
      background: var(--v-white);

      @include media(md) {
        padding: 2rem .7rem 1rem 0;
      }
    }

    .v-divider {
      display: none;
    }

    .m-form-buttons div {
      padding: 0 !important;
      padding-top: .2rem !important;
    }

    .m-block-form-buttons {
      padding: 0 !important;
      margin: 0 !important;

      .flex {
        padding: 0 !important;
      }
    }
  }
}
</style>
